<div class="main-content" style="overflow: hidden">
  <!-- left side with forms -->
  <div class="left-content">
    <img src="../../../assets/img/complete-logo.svg" alt="WeCloud Logo" class="logo-top">
    <div class="form-container">
      <div class="form-header">
        <h1>Bem-vindo de volta</h1>
        <p>Use seu e-mail e senha para acessar</p>
      </div>
      <div class="form-body">
        <div class="card-body password">
          <div class="input-container">
              <span>E-mail</span>
              <div class="input-field">
                <i nz-icon nzType="user" nzTheme="outline" class="input-icon"></i>
                <input type="text" placeholder="Digite seu e-mail" [formControl]="emailFormControl" (keyup.enter)="nextStep()">
              </div>
              <span class="input-error" *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                Insira um e-mail válido para continuar
              </span>
              <span class="input-error" *ngIf="emailFormControl.hasError('required') && emailFormControl.touched">
                E-mail é <strong>obrigatório!</strong>
              </span>
          </div>
          <div class="input-container" style="margin-top: 24px;">
            <span>Senha</span>
            <div class="input-field">
              <i nz-icon nzType="lock" nzTheme="outline" class="input-icon"></i>
              <input [type]="hide ? 'password' : 'text'" [formControl]="passwordFormControl" placeholder="Digite sua senha" (keyup.enter)="login()">
              <i nz-icon [nzType]="hide ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hide = !hide" class="clickable end-icon"></i>
            </div>
            <span class="input-error" *ngIf="passwordFormControl.hasError('required') && passwordFormControl.touched">
              Senha é <strong>obrigatório!</strong>
            </span>
          </div>
          <div class="actions-group">
              <button class="button" (click)="login()">Entrar <span nz-icon nzType="loading" nzTheme="outline" *ngIf="loading" class="loading-icon"></span></button>
              <a (click)="goToForgot()" class="forget clickable">Esqueceu sua senha?</a>
          </div>
        </div>
      </div>
    </div>
    <footer class="left-footer">
    <span>© {{ today | date: 'yyyy' }} Powered by WeSafer</span>
  </footer>
  </div>
  <!-- right side with image -->
  <div class="right-content">
    <div class="image-container">
      <img src="../../../assets/img/login-main-image.svg" alt="Login Image" />
    </div>
  </div>
</div>